export default __webpack_public_path__ + "static/media/pin_pickup.3f90c9b3.svg";